import cache from 'memory-cache';

export interface ICache {
    set<T>(key: string, value: T, ttl: number): boolean;
    get<T>(key: string): T | undefined;
    has(key: string): boolean;
    del(key: string): number;
    ttl(key: string, ttl: number): boolean;
}

export class MemoryCache implements ICache {
    set<T>(key: string, value: T, ttl: number): boolean {
        cache.put(key, value, ttl);
        return true;
    }

    get<T>(key: string): T | undefined {
        return cache.get(key);
    }

    has(key: string): boolean {
        return cache.keys().includes(key);
    }

    del(key: string): number {
        cache.del(key);
        return 1;
    }

    ttl(key: string, ttl: number): boolean {
        const value = cache.get(key);
        cache.del(key);
        cache.put(key, value, ttl);
        return true;
    }
}
